if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.swipeInitialized = false;
        this.arrowsInitialized = false;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.initTouchSwipe();
        this.initArrowButtons();
        this.updateArrowState();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
        );

        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;

        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');

        if (container) {
          container.scrollLeft =
            (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      initTouchSwipe() {
        // 모바일에서만 작동
        if (!window.matchMedia('(max-width: 749px)').matches) return;

        const container = this.querySelector('[role="document"]');

        if (!container || this.swipeInitialized) return;

        this.swipeInitialized = true;

        let startX = 0;
        let startY = 0;

        container.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length > 1) return;

            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
          },
          { passive: true }
        );

        container.addEventListener(
          'touchend',
          (event) => {
            if (event.changedTouches.length > 1) return;

            const endX = event.changedTouches[0].clientX;
            const endY = event.changedTouches[0].clientY;

            const diffX = startX - endX;
            const diffY = startY - endY;

            // 세로 움직임이 더 크면 무시
            if (Math.abs(diffY) > Math.abs(diffX)) return;

            // 최소 50px 이상 움직여야 swipe
            if (Math.abs(diffX) < 50) return;

            this.navigateMedia(diffX > 0 ? 'next' : 'prev');
          },
          { passive: true }
        );
      }

      navigateMedia(direction) {
        const mediaItems = [
          ...this.querySelectorAll('[data-media-id]')
        ];

        if (mediaItems.length <= 1) return;

        const activeMedia =
          this.querySelector('[data-media-id].active') || mediaItems[0];

        const currentIndex = mediaItems.indexOf(activeMedia);

        if (currentIndex === -1) return;

        let nextIndex;

        if (direction === 'next') {
          nextIndex = currentIndex + 1;
        } else {
          nextIndex = currentIndex - 1;
        }

        // 첫 이미지 이전 / 마지막 이미지 이후 이동 방지
        if (nextIndex < 0 || nextIndex >= mediaItems.length) return;

        const nextMedia = mediaItems[nextIndex];

        mediaItems.forEach((media) => {
          media.classList.remove('active');
        });

        nextMedia.classList.add('active');

        this.updateArrowState();
      }

      initArrowButtons() {
        // 모바일에서만 표시
        if (!window.matchMedia('(max-width: 749px)').matches) return;

        if (this.arrowsInitialized) return;

        const mediaItems = [
          ...this.querySelectorAll('[data-media-id]')
        ];

        if (mediaItems.length <= 1) return;

        this.arrowsInitialized = true;

        const prevButton = document.createElement('button');
        prevButton.type = 'button';
        prevButton.className = 'modal-arrow-prev';
        prevButton.setAttribute('aria-label', 'Previous image');
        prevButton.innerHTML = '&#10094;';

        const nextButton = document.createElement('button');
        nextButton.type = 'button';
        nextButton.className = 'modal-arrow-next';
        nextButton.setAttribute('aria-label', 'Next image');
        nextButton.innerHTML = '&#10095;';

        const buttonStyle = `
          position: fixed;
          top: 50%;
          transform: translateY(-50%);
          z-index: 10000;
          width: 42px;
          height: 42px;
          padding: 0;
          border: none;
          border-radius: 50%;
          background: rgba(0, 0, 0, 0.55);
          color: #fff;
          font-size: 25px;
          line-height: 42px;
          text-align: center;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
        `;

        prevButton.style.cssText =
          buttonStyle + 'left: 10px;';

        nextButton.style.cssText =
          buttonStyle + 'right: 10px;';

        prevButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.navigateMedia('prev');
        });

        nextButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.navigateMedia('next');
        });

        this.appendChild(prevButton);
        this.appendChild(nextButton);
      }

      updateArrowState() {
        const mediaItems = [
          ...this.querySelectorAll('[data-media-id]')
        ];

        if (mediaItems.length <= 1) return;

        const activeMedia =
          this.querySelector('[data-media-id].active') || mediaItems[0];

        const currentIndex = mediaItems.indexOf(activeMedia);

        const prevButton = this.querySelector('.modal-arrow-prev');
        const nextButton = this.querySelector('.modal-arrow-next');

        if (!prevButton || !nextButton) return;

        // 첫 이미지
        if (currentIndex === 0) {
          prevButton.style.opacity = '0.3';
        } else {
          prevButton.style.opacity = '1';
        }

        // 마지막 이미지
        if (currentIndex === mediaItems.length - 1) {
          nextButton.style.opacity = '0.3';
        } else {
          nextButton.style.opacity = '1';
        }
      }
    }
  );
}